import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { AffiliateRequest, AffiliateResponse } from 'src/app/models/affiliate.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { AffiliateService } from 'src/app/services/affiliate.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-affiliates',
  templateUrl: './affiliates.component.html',
  styleUrls: ['./affiliates.component.scss']
})
export class AffiliatesComponent implements OnInit {
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  vendors: VendorResponse[] = [];
  @ViewChild(PaginationComponent) paginationComponent: PaginationComponent;
  modalShowing = false;
  isCreating = false;
  vendorsIndex: { [key: string]: number } = {};
  filter = "";
  affiliateEditing: AffiliateRequest = new AffiliateRequest();
  converting : {[key:number]:boolean} = {};

  constructor(
    private affiliateService: AffiliateService,
    private vendorService: VendorService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getVendors();
  }

  getVendors() {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        this.vendors = response.data as VendorResponse[];
        for (let i = 0; i < this.vendors.length; i++) {
          const vendor = this.vendors[i];
          this.vendorsIndex[vendor.nit] = i;
          vendor['affiliateData'] = null;
        }
        this.affiliateService.getAffiliates().subscribe({
          next: (response: ResponseObject) => {
            var affiliates = response.data as AffiliateResponse[];
            affiliates.forEach((affiliate) => {
              if (this.vendorsIndex[affiliate.nit]) {
                this.vendors[this.vendorsIndex[affiliate.nit]]['affiliateData'] = affiliate;
              } else {
                var temporalVendor = new VendorResponse();
                temporalVendor.affiliate = affiliate.active;
                temporalVendor.code = affiliate.code;
                temporalVendor.nit = affiliate.nit;
                temporalVendor.name = affiliate.nombre;
                temporalVendor['affiliateData'] = affiliate;
                this.vendors.push(temporalVendor);
              }
            });
            this.vendors.sort((a, b) => a.name.localeCompare(b.name));
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
        this.pagination.total = this.vendors;
        this.paginationComponent.refresh();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  convert(vendor: VendorResponse) {
    var newAfilliate = new AffiliateRequest();
    newAfilliate.celular = vendor.contactCellphone;
    newAfilliate.direccion = vendor.address;
    newAfilliate.dpi = vendor.dpi;
    newAfilliate.foto = null;
    newAfilliate.mail = vendor.contactMail;
    newAfilliate.nacimiento = null;
    newAfilliate.nit = vendor.nit;
    newAfilliate.nombre = vendor.name;
    newAfilliate.vendorId = vendor.id;
    if (vendor['affiliateData']) {
      if (!this.converting[vendor.nit]){
        this.converting[vendor.nit] = true;
        this.affiliateService.convertToAffiliate(vendor.id, newAfilliate).subscribe({
          next: (response: ResponseObject) => {
            this.converting[vendor.nit] = false;
            this.toastService.success(!vendor.affiliate ? "Se convirtió correctamente en afiliado al cliente" : "Se desactivo el estado como afiliado del cliente!");
            vendor.affiliate = !vendor.affiliate;
          },
          error: (error: HttpErrorResponse) => {
            this.converting[vendor.nit] = false;
            this.toastService.error(error.error.message);
          }
        })
      }
    } else {
      this.isCreating = true;
      this.affiliateEditing = newAfilliate;
      this.modalShowing = true;
    }
  }

  create() {
    this.isCreating = true;
    this.affiliateEditing = new AffiliateRequest();
    this.modalShowing = true;
  }

  edit(vendor: VendorResponse) {
    var temp = new AffiliateRequest();
    if (vendor['affiliateData']) {
      var ad = vendor['affiliateData'] as AffiliateResponse;
      temp['id'] = ad.id;
      temp.celular = ad.celular;
      temp.direccion = ad.direccion;
      temp.dpi = ad.dpi;
      temp.foto = ad.foto;
      temp.mail = ad.mail;
      temp.nacimiento = new Date(ad.nacimiento).toISOString().split("T")[0];
      temp.nit = ad.nit;
      temp.nombre = ad.nombre;
      temp.vendorId = ad.vendorId;
      this.isCreating = false;
    } else {
      // temp['id'] = vendor.id;
      temp.celular = vendor.contactCellphone;
      temp.direccion = vendor.address;
      temp.dpi = vendor.dpi;
      temp.foto = null;
      temp.mail = vendor.contactMail;
      temp.nacimiento = null;
      temp.nit = vendor.nit;
      temp.nombre = vendor.name;
      temp.vendorId = vendor.id;
      this.isCreating = true;
    }
    this.affiliateEditing = temp;
    this.modalShowing = true;
  }

  filtering() {
    this.pagination.total = this.vendors.filter((vendor) => {
      return vendor.code.includes(this.filter) || vendor.name.toLowerCase().includes(this.filter.toLowerCase()) || vendor.nit.toLowerCase().includes(this.filter.toLowerCase())
    });
    this.paginationComponent.reset();
  }

  close(changed) {
    if (changed) {
      this.getVendors();
    }
    this.modalShowing = false;
    this.affiliateEditing = new AffiliateRequest();
    this.isCreating = true;
  }
}
